<template>
  <div class="callme_total_wrap hidden-xs-only">
    <div class="callme_top_wrap">
      <el-col class="flexLayout_row" style="justify-content: center;font-size: x-large;color: #fff;height: 100%;">
      <div class="flexLayout_row" style="border-right: 1px solid #fff;padding-right: 21px;"><i class="el-icon-phone-outline" style="font-size: xx-large;padding: 7px;border-radius: 50%;border: 1px solid #fff;height: 100%;margin-right: 14px;" /> 021-53082528</div>
      <div class="flexLayout_row" style="font-size: medium;padding-left: 21px;"><span style="font-size: larger;margin-right: 21px;">选择易曙智慧园区</span><span>加快实现园区高质量发展</span></div>
      </el-col>
    </div>
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="items_wrap">
          <div class="item_tit">产品矩阵</div>
          <div class="item_options">
            <span @click="handleToRouter('/production/1')">招商管理平台</span>
            <span @click="handleToRouter('/production/2')">运营管理平台</span>
            <span @click="handleToRouter('/production/3')">企业服务平台</span>
          </div>
        </div>
 
        <div class="items_wrap">
          <div class="item_tit">联系我们</div>
          <div class="item_options">
          
            <div class="massage_show">
              <p>{{ cityInfomation[showCity].phone }}</p>
              <p>{{ cityInfomation[showCity].eamil }}</p>
              <p>{{ cityInfomation[showCity].address }}</p>
            </div>
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down" style="margin-left: 120px">
          <div class="item_tit">ESOO-Park</div>
          <div class="item_options">
            <img src="@/assets/img/app.png" alt="" />
            <span style="text-align: center; margin-top: 15px"
              >APP下载</span
            >
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down">
          <div class="item_tit">园区招商通</div>
          <div class="item_options">
            <img src="@/assets/img/investMini.jpg" alt="" />
            <span style="text-align: center; margin-top: 15px"
              >微信扫一扫</span
            >
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down">
          <div class="item_tit">运营服务管理</div>
          <div class="item_options">
            <img src="@/assets/img/esoofmini.jpg" alt="" />
            <span style="text-align: center; margin-top: 15px"
              >微信扫一扫</span
            >
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
        <span>友情链接:</span>
        <a href="https://www.tungee.com/">探迹科技</a>
        <p>
          Copyright ©2025 上海易曙软件有限公司 . All Rights Reserved . 沪ICP备17033433号-5
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      cityInfomation: [
        {
          phone: '021-53082528',
          eamil: 'fancheng.zou@esoosoft.com',
          address: '上海市浦东新区张江路69号南三楼307室',
        }
      ],
      showCity: 0,
    }
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1
    },
    handleToRouter(url) {
      this.$router.replace(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.flexLayout_row{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.callme_total_wrap {
  width: 100%;
  margin-top: 80px;
  .callme_top_wrap {
    width: 100%;
    height: 300px;
    background: linear-gradient(62deg, rgba(0, 128, 255, 0.84) 0%, rgba(87, 6, 165, 0.72) 100%);
    background-size: 100% 100%;
  }
  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 70px;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;
      border-bottom: solid #363636 2px;
      .items_wrap {
        margin-right: 100px;
        .item_tit {
          font-size: 22px;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 120px;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300PX;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300PX;
            height: 80px;
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }
      p {
        font-size: 16px;
        color: #4e5557;
      }
    }
  }
}
</style>